export default () => {
  return {
    users: [],
    /** What the live `users` binding was built for, so it is never reused for different inputs. */
    boundKey: null,
    /** The binding still in flight for `boundKey`, so a second caller awaits it rather than its own. */
    pendingBinding: null,
  };
};
